import { MapboxGLMapper } from './MapboxGLMapper'

export class Mapper {
  static get instance () {
    if (!this._instance) {
      this._instance = new MapboxGLMapper()
    }

    return this._instance
  }

  static get defaultHome () {
    // Hawaiian islands
    return {
      center: [-157.72, 20.6],
      zoom: 7
    }
  }
}
